import { oc } from "@orpc/contract";
import { z } from "zod";

export const ExtractPricelistFromPdfInputSchema = z.object({
  fileBase64: z.string(),
  fileName: z.string(),
});

export const PricelistTableSchema = z.object({
  headers: z.array(z.string()),
  rows: z.array(z.record(z.string(), z.string())),
});

export const ExtractPricelistFromPdfResponseSchema = z.object({
  tables: z.array(PricelistTableSchema),
});

export const pricelistContracts = {
  extractFromPdf: oc
    .input(ExtractPricelistFromPdfInputSchema)
    .output(ExtractPricelistFromPdfResponseSchema)
    .route({ summary: "Extract pricelist CSV from a PDF via LLM" }),
} as const;

export type PricelistTable = z.infer<typeof PricelistTableSchema>;
export type ExtractPricelistFromPdfInput = z.infer<
  typeof ExtractPricelistFromPdfInputSchema
>;
export type ExtractPricelistFromPdfResponse = z.infer<
  typeof ExtractPricelistFromPdfResponseSchema
>;
